import React from 'react';
import {observer, inject, IReactComponent} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {ILoginStore} from './login.stores';
import {IAppRootStore} from '../../app.root.store';
import LoginLayoutComponent from './components/layout/index';

import '@techsee/techsee-ui-common/lib/_shared/icons.css';

interface LoginMobileViewProps {
    loginStore: ILoginStore;
    rootStore: IAppRootStore;
}

@observer
export class LoginMobileViewComponent extends TechseeBaseComponent<LoginMobileViewProps> {
    renderInternal(): JSX.Element {
        this.addCssClass('login-mobile-layout');

        return (
            <div className={this.renderCssClasses()}>
                <LoginLayoutComponent />
            </div>
        );
    }
}

export const LoginMobileView = inject('rootStore', 'loginStore')(LoginMobileViewComponent) as IReactComponent;
